import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Dropdown, DropdownItem, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.toggleSelect = this.toggleSelect.bind(this);
    this.state = {
        collapsed: true,
        dropdownOpen: false,
        nexus: [],
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
    }

    toggleSelect() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    async componentDidMount() {
        var response = await fetch('nexus');
        const data = await response.json();

        this.setState({ nexus: data });
    }

  render () {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" light>
          <Container>
            <NavbarBrand tag={Link} to="/">Weston Diagnostic Nexus</NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
            <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggleSelect}>
              <DropdownToggle nav caret>
                Pick a Nexus
              </DropdownToggle>
              <DropdownMenu>
                {this.state.nexus.map((nexus, idx) => (
                    <div key={idx}>
                        <DropdownItem tag={Link} className="text-dark" push to={"/DiagnosticNexus/" + nexus.id.toString()}>{ nexus.name }</DropdownItem>
                    </div>
                ))}
              </DropdownMenu>
            </Dropdown>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
